import { gql, useQuery } from "@apollo/client"
import { InjectedOptions } from "@oysterhr/core"
import { Query } from "@oysterhr/schema"
import { MONEY_FIELDS } from "~/shared/fragments/MoneyFields"

export const BENEFITS_STAFF_EMPLOYMENT_ENROLLED_PACKAGES_QUERY = gql`
  ${MONEY_FIELDS}
  query StaffBenefitsEmploymentPackagesOverview(
    $engagementId: ID!
    $useSalaryCurrencyCode: Boolean
  ) {
    employment(employmentId: $engagementId) {
      salaryCurrencyCode
      countryCode
      company {
        id
      }
    }
    engagement(engagementId: $engagementId) {
      id
      engagementType
      benefitsEnrolledPackages {
        collection {
          id
          tier {
            id
            name
            fee(engagementId: $engagementId, useSalaryCurrencyCode: $useSalaryCurrencyCode) {
              currencyCode
              formatted
              subunit
              subunitToUnit
            }
          }

          enrollments {
            collection {
              id
              state
              coverageStartDate
              cancelledAt
              enrolledAt
              coverageEndDate
              availableEvents
              cancellationReason
              totalPrice {
                ...MoneyFields
              }
              totalPriceInvoicedCompany {
                ...MoneyFields
              }
              tier {
                id
                name
                fee(engagementId: $engagementId, useSalaryCurrencyCode: $useSalaryCurrencyCode) {
                  ...MoneyFields
                }
              }
              plan {
                id
                name
                category
                guideUrl
                descriptiveName
                provider {
                  id
                  name
                  automated
                }
                fee(engagementId: $engagementId, useSalaryCurrencyCode: $useSalaryCurrencyCode) {
                  ...MoneyFields
                }
              }
              engagement {
                id
                teamMemberName
                benefitsDescription
                teamMember {
                  id
                  name
                  avatarUrl
                }
              }
            }
          }
        }
      }
    }
  }
`

interface QueryInput {
  engagementId: string
  useSalaryCurrencyCode: boolean
}

export const useEmploymentPackagesOverview = (
  options: InjectedOptions<Pick<Query, "engagement" | "employment">, QueryInput>,
) => {
  const { data, ...rest } = useQuery(BENEFITS_STAFF_EMPLOYMENT_ENROLLED_PACKAGES_QUERY, {
    ...options,
    fetchPolicy: "cache-and-network",
  })

  return {
    ...rest,
    engagement: data?.engagement,
    employment: data?.employment,
  }
}
